var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"carousel",staticClass:"carousel",class:{
  'carousel--dragging': _vm.dragging
},style:({
  '--swipe-offset': _vm.swipeOffset,
  '--index': _vm.index
})},[_c('div',{ref:"track",staticClass:"carousel__track"},[_vm._t("default")],2),_c('div',{staticClass:"carousel__nav"},[_c('ul',{staticClass:"carousel__dots"},_vm._l((_vm.slides),function(idx){return _c('li',{key:idx,staticClass:"carousel__dots__item",class:{'carousel__dots__item--active': idx === _vm.index + 1},on:{"click":function($event){_vm.index = idx - 1}}})}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }